export default __webpack_public_path__ + "static/media/yacht1.1d01b6e6.webp";